import UserAccountResource  from 'resources/user/UserAccountResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class EmailResource extends UserAccountResource {
  static urlRoot = '/emails'
}
